export default function SectionTitle({ title, classes }) {
  return (
    <h1
      className={`text-[30px] font-bold md:text-[40px] ${classes && classes}`}
    >
      {title}
    </h1>
  );
}
